export default "ui-definition-list{display:flex;flex-direction:column;gap:var(--ui-spacing-xlarge)}\n";